import { FC, useEffect, useMemo } from 'react';
import { GroupAwardsItem, GroupAwards as GroupAwardsModel } from 'store/candidate/types';
import { isArray } from 'lodash-es';
import { Divider, TnCCheckbox } from '@britishcouncil/react-solas-ors3';
import { FormFields } from '@britishcouncil/react-forms';
import { GroupAward } from './GroupAward';

export const GroupAwards: FC<{
  groupAwards: GroupAwardsItem[] | undefined;
  fields: FormFields<GroupAwardsModel>;
}> = ({ groupAwards = [], fields }) => {
  const showConfirmAgreementCheckbox = useMemo(
    () => isArray(fields.groupAwardExams) && !!fields.groupAwardExams?.find((x) => x.isSelected.value),
    [fields.groupAwardExams],
  );

  useEffect(() => {
    if (!showConfirmAgreementCheckbox && fields.agreementConfirmed.value) {
      fields.agreementConfirmed.onChange(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fields.agreementConfirmed.value, showConfirmAgreementCheckbox]);

  if (!fields.groupAwardExams[0]) return null;

  return (
    <>
      <h2>Group awards</h2>

      {fields.groupAwardExams.map((field, i) => (
        <GroupAward key={i} fields={field} groupAward={groupAwards[i]} />
      ))}

      {showConfirmAgreementCheckbox && (
        <TnCCheckbox {...fields.agreementConfirmed}>
          <strong>
            * I accept that Group Awards may not be granted by the Examination Board if I do not meet the criteria.
          </strong>
        </TnCCheckbox>
      )}

      <Divider />
    </>
  );
};
